(function() {
  function openCartDrawer() {
    document.querySelector('.js-drawer-open-cart').click();
  }
  
   window.addEventListener('DOMContentLoaded', () => {
    const url = new URL(window.location.href);
    const hasCartParam = url.searchParams.get('cart') === 'true';

    if (hasCartParam) {
      // Call your method to open the cart drawer
      openCartDrawer?.();

      // Remove the `cart` param from the URL without reloading the page
      url.searchParams.delete('cart');
      window.history.replaceState({}, '', url.toString());
    }
  });
})();